<template>
  <div>
    <v-card v-if="userInfo">
      <v-card-text>
        <v-container grid-list-md py-0>
          <v-toolbar dense class="mb-4 mt-2 headline">
            <v-toolbar-title class="headline user-title">
              <p class="d-inline-flex">{{ userInfo.username }}</p>
              <p class="d-inline-flex a360id">
              {{ showA360}}
              </p>
            </v-toolbar-title>
          </v-toolbar>
          <v-layout wrap row class="pb-3">
            <v-flex xs6 md3>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="userInfo.firstName"
                label="First Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-btn
                @click="
                  updateUser(
                    'given_name',
                    userInfo.firstName,
                    'firstNameStatus',
                    'First Name',
                    'firstName'
                  )
                "
                :disabled="!adminOrSuper"
                >Update First Name</v-btn
              >
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="userInfo.lastName"
                label="Last Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-btn
                @click="
                  updateUser(
                    'family_name',
                    userInfo.lastName,
                    'lastNameStatus',
                    'Last Name',
                    'lastName'
                  )
                "
                :disabled="!adminOrSuper"
                >Update Last Name</v-btn
              >
            </v-flex>
            <template v-if="!mersBranded">
              <v-flex xs6 md3>
                <v-text-field
                  :color="appButtonColor"
                  hide-details
                  v-model="createdDate"
                  readonly
                  label="Created Date"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md3>
                <v-text-field
                  :color="appButtonColor"
                  hide-details
                  v-model="userTerms"
                  readonly
                  label="Accepted Terms"
                ></v-text-field>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs6 md6>
                <v-text-field
                  :color="appButtonColor"
                  hide-details
                  v-model="createdDate"
                  readonly
                  label="Created Date"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6>
                <v-text-field
                  :color="appButtonColor"
                  hide-details
                  v-model="userTerms"
                  readonly
                  label="Accepted Terms"
                ></v-text-field>
              </v-flex>
            </template>
            <v-flex xs12 md6 v-if="!mersBranded">
              <v-text-field
                hide-details
                v-model="userSSN"
                readonly
                label="SSN"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                :color="appButtonColor"
                readonly
                hide-details
                :value="userInfo.enabled ? 'Active' : 'Inactive'"
                label="Cognito Account Status"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-btn
                @click="changeUserAccount(!userInfo.enabled)"
                :disabled="!adminOrSuper"
                >{{
                  userInfo.enabled ? "Disable Account" : "Enable Account"
                }}</v-btn
              >
            </v-flex>
            <v-flex xs6 md3>
              <v-select
                    :items="profileStatus"
                    label="Profile Status"
                    v-model="userInfo.status"
                    item-text="title"
                    item-value="val"
                    :color="appButtonColor"
                    hide-details
                  ></v-select>
            </v-flex>
            <v-flex xs6 md3>
              <v-btn
                @click="
                  updateUser(
                    'status',
                    userInfo.status,
                    'statusStatus',
                    'Status',
                    'status'
                  )
                "
                :disabled="!adminOrSuper"
                >Update Status</v-btn
              >
            </v-flex>
            <v-flex xs6 md3 v-if="!mersBranded">
              <v-text-field
                :success="cifStatus"
                hide-details
                v-model="userInfo.cif"
                label="CIF"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3 v-if="!mersBranded">
              <v-btn
                @click="
                  updateUser(
                    'custom:cif',
                    userInfo.cif,
                    'cifStatus',
                    'CIF',
                    'cif'
                  )
                "
                :disabled="!adminOrSuper"
                >Update CIF</v-btn
              >
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                :color="appButtonColor"
                hide-details
                :readonly="!adminOrSuper"
                v-model="userInfo.email"
                type="text"
                label="Email"
                autocomplete="new-email"
                :success="emailStatus"
              >
                <template v-slot:append>
                  <v-icon :color="userInfo.emailVerified ? 'green' : 'dark'"
                    >check_circle</v-icon
                  >
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-btn
                :loading="emailLoading"
                @click="
                  updateUser(
                    'email',
                    userInfo.email,
                    'emailStatus',
                    'Email',
                    'email'
                  )
                "
                :disabled="!adminOrSuper"
                >Update Email</v-btn
              >
            </v-flex>
            <v-flex xs6 md3 v-if="!mersBranded">
              <v-text-field
                hide-details
                v-model="userInfo.birthdate"
                maxlength="8"
                label="Birthdate"
                name="birthdate"
                mask="##/##/####"
                :success="birthdateStatus"
                :readonly="!adminOrSuper"
              ></v-text-field>
              <span>{{ errors.first("birthdate") }}</span>
            </v-flex>
            <v-flex xs6 md3 v-if="!mersBranded">
              <v-btn
                @click="
                  updateUser(
                    'custom:dateofbirth',
                    userInfo.birthdate,
                    'birthdateStatus',
                    'Birthdate',
                    'birthdate'
                  )
                "
                :disabled="!adminOrSuper"
                >Update Birthday</v-btn
              >
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                :color="appButtonColor"
                readonly
                hide-details
                v-model="userInfo.userStatus"
                label="Status"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-btn @click="resetPass" :disabled="!adminOrSuper"
                >Reset Password</v-btn
              >
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap class="mobile-order">
                <v-flex xs6 md3>
                  <v-text-field
                    :color="appButtonColor"
                    readonly
                    hide-details
                    v-model="passCode"
                    label="Passcode"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-btn @click="generatePasscode" :disabled="!adminOrSuper"
                    >Generate Passcode</v-btn
                  >
                </v-flex>
                <v-flex xs6 md3>
                  <v-input
                    class="mfa-label"
                    hide-details
                    label="MFA Options"
                  ></v-input>
                  <v-radio-group
                    hide-details
                    v-model="mfa"
                    row
                    class="mt-0"
                  >
                    <v-radio
                      :color="appButtonColor"
                      label="Default"
                      value="securenow"
                    ></v-radio>
                    <v-radio
                      :color="appButtonColor"
                      disabled
                      label="Auth App"
                      value="aws"
                    ></v-radio>
                    <v-radio
                      :color="appButtonColor"
                      label="Off"
                      value="off"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6 md3>
                  <v-btn @click="setMFA" :disabled="!adminOrSuper"
                    >Update MFA</v-btn
                  >
                </v-flex>

                <v-flex xs6 md3>
                  <v-select
                    :items="primaryPhone"
                    label="Primary Phone Type"
                    v-model="userInfo.primary"
                    item-text="title"
                    item-value="val"
                    :color="appButtonColor"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6 md3>
                  <v-btn :loading="primaryLoading" @click="updatePrimary" :disabled="!adminOrSuper"
                    >Update Primary</v-btn
                  >
                </v-flex>
                <v-flex xs3 md2>
                  <v-select
                    class="country-select"
                    v-model="currentPhones.mobile.countryCode"
                    :items="countries"
                    item-text="label"
                    item-value="value"
                    label="Mobile"
                    :color="appButtonColor"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6 md2>
                  <v-text-field
                    hide-details
                    v-model="currentPhones.mobile.number"
                    :color="appButtonColor"
                    :mask="currentPhones.mobile.countryCode === '1' ? '(###) ### - ####' : '##############'"
                  >
                  <template v-slot:append>
                    <v-icon @click="removePhone('mobile')" v-if="iconTypeCheck('mobile')" color="red">remove_circle</v-icon>
                  </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs3 md2>
                  <v-btn :loading="mobileLoading" @click="updatePhone('mobile')" :disabled="!adminOrSuper"
                    >Update Mobile</v-btn
                  >
                </v-flex>
                <v-flex xs3 md2>
                  <v-select
                    hide-details
                    class="country-select"
                    v-model="currentPhones.home.countryCode"
                    :items="countries"
                    item-text="label"
                    item-value="value"
                    label="Home"
                    :color="appButtonColor"
                  ></v-select>
                </v-flex>
                <v-flex xs6 md2>
                  <v-text-field
                    hide-details
                    v-model="currentPhones.home.number"
                    :color="appButtonColor"
                    :mask="currentPhones.home.countryCode === '1' ? '(###) ### - ####' : '##############'"
                  >
                  <template v-slot:append>
                    <v-icon @click="removePhone('home')" v-if="iconTypeCheck('home')" color="red">remove_circle</v-icon>
                  </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs3 md2>
                  <v-btn :loading="homeLoading" @click="updatePhone('home')" :disabled="!adminOrSuper"
                    >Update Home</v-btn
                  >
                </v-flex>
                <v-flex xs3 md2>
                  <v-select
                    hide-details
                    class="country-select"
                    v-model="currentPhones.work.countryCode"
                    :items="countries"
                    item-text="label"
                    item-value="value"
                    label="Work"
                    :color="appButtonColor"
                  ></v-select>
                </v-flex>
                <v-flex xs6 md2>
                  <v-text-field
                    hide-details
                    v-model="currentPhones.work.number"
                    :color="appButtonColor"
                    :mask="currentPhones.work.countryCode === '1' ? '(###) ### - ####' : '##############'"
                  >
                  <template v-slot:append>
                    <v-icon @click="removePhone('work')" v-if="iconTypeCheck('work')" color="red">remove_circle</v-icon>
                  </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs3 md2>
                  <v-btn :loading="workLoading" @click="updatePhone('work')" :disabled="!adminOrSuper"
                    >Update Work</v-btn
                  >
                </v-flex>
                <v-flex xs6 md3>
                  <v-select
                        :items="emailMfaStatus"
                        label="Disable Email MFA"
                        v-model="userInfo.passwordReset"
                        item-text="title"
                        item-value="val"
                        :color="appButtonColor"
                        hide-details
                      ></v-select>
                </v-flex>
                <v-flex xs6 md3>
                  <v-btn
                    @click="
                      updateUser(
                        'passwordReset',
                        userInfo.passwordReset,
                        'passwordResetStatus',
                        'Disable Email MFA',
                        'passwordReset'
                      )
                    "
                    :disabled="!adminOrSuper"
                    >Update Email MFA</v-btn
                  >
                </v-flex>

                <!-- <v-flex xs6>
                  <v-input
                    class="mfa-label mt-1"
                    hide-details
                    label="Alternate Phones"
                  ></v-input>
                  <ol class="pl-3 pt-1" v-if="alternatePhones.length">
                    <li v-for="phone in alternatePhones" :key="phone.PhoneID">
                      <span class="alt-phone mr-1">{{
                        phone.PhoneNumber
                      }}</span>
                      <v-icon
                        :disabled="!adminOrSuper"
                        color="red"
                        small
                        @click="removePhone(phone.PhoneID)"
                        >cancel</v-icon
                      >
                    </li>
                  </ol>
                  <p class="pt-1" v-else>None</p>
                </v-flex> -->
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout mt-3 wrap v-if="!mersBranded">
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isAdmin"
                label="isAdmin"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isAlerus"
                label="isAlerus"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isEnvestnet"
                label="isEnvestnet"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isMERS"
                label="isMERS"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isFCMM"
                label="isFCMM"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.OCEAccess"
                label="OCEAccess"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.CFUAccess"
                label="CFUAccess"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isICapital"
                label="isICapital"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isKeating"
                label="isKeating"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.partAccess"
                label="partAccess"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.planAccessAdmin"
                label="planAccessAdmin"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isWexFLXAdmin"
                label="isWexFLXAdmin"
              ></v-switch>
            </v-flex>
            <v-flex :class="flagWidth">
              <v-switch
                :color="appButtonColor"
                :readonly="!adminOrSuper"
                v-model="userFlags.isMersContact"
                label="isMersContact"
              ></v-switch>
            </v-flex>
            <v-flex xs6 sm3 lg2 pa-0>
              <v-btn
                @click="
                  updateUser(
                    'custom:userFlags',
                    JSON.stringify(userFlags),
                    'userFlagsStatus',
                    'User Flags',
                    'userFlags'
                  )
                "
                :disabled="!adminOrSuper"
                class="ma-0"
                >Update Flags</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout wrap v-else>
            <v-flex xs6 sm3 md2>
              <v-switch
                color="#34715a"
                readonly
                v-model="userFlags.isAdmin"
                label="isAdmin"
              ></v-switch>
            </v-flex>
          </v-layout>
          <v-toolbar dense class="mt-4" v-if="events.length">
            <v-toolbar-title>Latest Events</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            v-if="events.length"
            :headers="eventHeaders"
            :items="events"
            :rows-per-page-items="[10]"
            class="elevation-1 table-striped events"
            :pagination.sync="eventPagination"
          >
            <template slot="items" slot-scope="props">
              <tr class="row" @click="showActionDetails(props.item)">
                <td>
                  {{ new Date(props.item.createdAt).toLocaleString("en-US") }}
                </td>
                <td>{{ props.item.action }}</td>
                <td>{{ appName(props.item.app) }}</td>
                <td>{{ props.item.actionBy }}</td>
                <td>{{ props.item.ipAddress }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
    <v-progress-linear
      v-else
      indeterminate
      :color="appButtonColor"
    ></v-progress-linear>
    <vue-snotify></vue-snotify>
    <v-dialog v-model="actionDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ actionItem.action }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Date"
                  :value="
                    new Date(actionItem.createdAt).toLocaleString('en-US')
                  "
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Application"
                  :value="appName(actionItem.app)"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Action On"
                  :value="actionItem.actionOn"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Action By"
                  :value="actionItem.actionBy"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-textarea
                  :color="appButtonColor"
                  label="Previous Value"
                  :value="actionItem.currVal ? actionItem.currVal : 'NA'"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6>
                <v-textarea
                  :color="appButtonColor"
                  label="New Value"
                  :value="actionItem.newVal"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="User Details"
                  :value="actionItem.browserDetails"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="IP Address"
                  :value="actionItem.ipAddress"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="appButtonColor" flat @click="actionDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState, mapGetters } from "vuex";
import countries from "aws-amplify-vue/src/assets/countries";
export default {
  name: "user",
  data() {
    return {
      countries,
      primaryLoading: false,
      mobileLoading: false,
      homeLoading: false,
      workLoading: false,
      country: "",
      phone: "",
      cifStatus: false,
      phonePrimary: "",
      firstNameStatus: false,
      lastNameStatus: false,
      emailStatus: false,
      phoneStatus: false,
      prefUsernameStatus: false,
      birthdateStatus: false,
      statusStatus: false,
      passwordResetStatus: false,
      userFlagsStatus: false,
      eventPagination: {
        sortBy: "createdAt",
        descending: true,
        rowsPerPage: 20,
      },
      authUrl: "",
      accountChoices: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      primaryPhone: [
        {
          title: "Mobile",
          val: "mobile"
        },
        {
          title: "Home",
          val: "home"
        },
        {
          title: "Work",
          val: "work"
        }
      ],
      profileStatus: [
        {
          title: "Active",
          val: "active"
        },
        {
          title: "Pending",
          val: "pending"
        }
      ],
      emailMfaStatus: [
        {
          title: "True",
          val: true
        },
        {
          title: "False",
          val: false
        }
      ],
      search: "",
      dialog: false,
      actionDialog: false,
      emailError: "",
      passwordInfo: "",
      sponsorCopy: {},
      sponsor: false,
      newSponsor: {
        username: "",
        password: "",
        atts: {
          birthdate: "0000000000",
          email: "",
          email_verified: "true",
          phone_number: "",
          "custom:dateofbirth": "",
          // "custom:agreedterms": new Date().toISOString(),
          given_name: "",
          family_name: "",
        },
        flags: {
          isAdmin: false,
          isAlerus: false,
          isFCMM: false,
          isICapital: false,
          isKeating: false,
          isMERS: false,
          isEnvestnet: false,
          OCEAccess: false,
          CFUAccess: false,
          partAccess: false,
          isWexFLXAdmin: false,
          isMersContact: false
        },
      },
      infoColor: "green",
      rules: {
        birthdate: (v) => v.length === 0 || v.length <= 8 || "Error",
        required: (v) => !!v || "Required",
        min: (v) => v.length >= 8 || v.length === 0 || "Min 8 characters",
        upper: (v) =>
          /[A-Z]/.test(v) || v.length === 0 || "Must include uppercase letter",
        number: (v) =>
          /[0-9]/.test(v) || v.length === 0 || "Must include number",
        email: (v) => /.+@.+/.test(v) || "Invalid email address",
      },
      phoneLoading: false,
      emailLoading: false,
      allAccounts: [],
      editedItem: {},
      clonedItem: {},
      clonedUserFlags: "",
      loadingPercentage: 0,
      tab: null,
      newUrl: false,
      branchLoading: false,
      accountLoading: false,
      actionLoading: false,
      actionTagsLoading: false,
      fullAccountLoading: false,
      newPassword: "",
      mfa: "",
      currentMFA: "",
      system: "",
      mfaConfig: {
        mfaTypes: ["TOTP"],
      },
      pagination: {
        descending: true,
        sortBy: "createdAt",
      },
      vendor: [],
      account: [],
      actions: [],
      actionTags: [],
      systems: ["retirement", "avoka", "banking", "wex", "elan", "envestnet"],
      branch: null,
      dashboardReady: false,
      branchInfo: "",
      fullAccount: "",
      newEmail: false,
      newEmailVerified: false,
      birthdayMask: "",
      emailVerifiedClicked: false,
      snId: "",
      snPhoneId: "",
      token: "",
      authToken: "",
      userFlags: {},
      passCode: "",
      actionItem: {},
      copy: false,
      emptyPhone: {
        countryCode: "1",
        number: "",
        type: ""
      },
      currentPhones: {
        mobile: {},
        home: {},
        work: {}
      },
      copyCurrentPhones: {
        mobile: {},
        home: {},
        work: {}
      },
      userAtts: {
        email: "email",
        phone: "phone_number",
        // alerus360id: "custom:alerus360id",
        cif: "custom:cif",
        birthdate: "custom:dateofbirth",
        prefUsername: "preferred_username",
        userFlags: "custom:userFlags",
        // emailVerified: "email_verified"
      },
      eventHeaders: [
        { text: "Date", sortable: true, value: "createdAt" },
        { text: "Action", sortable: true, value: "action" },
        { text: "App", sortable: true, value: "app" },
        { text: "Action By", sortable: true, value: "actionBy" },
        { text: "IP Address", sortable: true, value: "ipAddress" },
      ],
      actionHeaders: [
        { text: "Workout", value: "workout" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phoneNumber" },
      ],
      userHeaders: [
        { text: "Username", value: "username" },
        // { text: "Alerus 360 ID", value: "alerusId" },
        { text: "CIF", value: "cif" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phone" },
        { text: "Date of Birth", value: "dateOfBirth" },
      ],
    };
  },
  watch: {
    // userFlags: {
    //   handler: function(val) {
    //     this.userInfo.userFlags = JSON.stringify(val);
    //   },
    //   deep: true
    // },
    changedEmail(val) {
      if (val) {
        this.newEmail = true;
        this.editedItem.emailVerified = false;
      } else {
        if (!this.emailVerifiedClicked) {
          this.editedItem.emailVerified = true;
        }
        this.newEmail = false;
      }
    },
  },
  async created() {
    await this.$store.dispatch("user/checkUser");
    await this.$store.dispatch("accounts/getUserInfo", this.$route.params.id);
    this.snId = this.userInfo.alerus360id
      ? this.userInfo.alerus360id.replace(/-/g, "")
      : this.$route.params.id;
    this.$store.dispatch("accounts/getUserLogs", this.$route.params.id);
    // this.$store.dispatch("accounts/secureNowStatus", this.snId);
    this.clonedItem = JSON.parse(JSON.stringify(this.userInfo));
    this.splitPhone();
    this.setupPhones();
    this.phonePrimary = JSON.parse(JSON.stringify(this.userInfo.primary))
    this.setFlags(this.userInfo.userFlags);
    // this.checkFlagsForSN();
    // await this.$store.dispatch("user/checkSecureNowPhones", this.snPhoneId);
    if (this.mersBranded) {
      this.newSponsor.flags.isMERS = true;
    }
    this.$root.$on("createSponsor", () => {
      if (this.adminOrSuper) this.sponsor = true;
    });
    this.sponsorCopy = JSON.parse(JSON.stringify(this.newSponsor));
    // set User MFA
    this.setUserMFA(this.userInfo);
  },
  computed: {
    ...mapState("user", [
      "confirmed",
      "user",
      "state",
      "mersBranded",
      "snPhones",
    ]),
    ...mapState("accounts", ["events", "userInfo", "snStatus"]),
    ...mapGetters("user", ["isAuthenticated", "userGroup", "adminOrSuper"]),
    flagWidth() {
      if (this.$vuetify.breakpoint.xs) return "xs6"
      else return "shrink mr-4"
    },
    showA360(){
      return this.userInfo.alerus360id ? this.userInfo.alerus360id : this.userInfo.sponsor ? this.userInfo.sponsor : "No A360Id Found"
    },
    userSSN() {
      if (this.userInfo.ssn) {
        let ssn = this.userInfo.ssn;
        return `XXX-XX-${ssn.slice(-4)}`;
      } else return "Not Found";
    },
    alternatePhones() {
      return this.snPhones.filter(
        (item) => this.clonedItem.phone !== item.PhoneNumber
      );
    },
    superOrSysAdmin() {
      if (this.userGroup === "Super" || this.userGroup === "SystemAdmin") {
        return true;
      } else return false;
    },
    snBypass() {
      if (this.userInfo.snMFABypass === null)
        this.userInfo.snMFABypass = "false";
      return this.capitalize(JSON.parse(this.userInfo.snMFABypass).toString());
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    userTerms() {
      return new Date(this.userInfo.terms).toLocaleString("en-US");
    },
    createdDate() {
      return new Date(this.userInfo.created).toLocaleString("en-US");
    },
    indexedAccounts() {
      return this.accounts.map((item, index) => ({
        id: index,
        ...item,
      }));
    },
    changedEmail() {
      if (this.clonedItem.email !== this.editedItem.email) return true;
      else return false;
    },
    changedEmailVerified() {
      if (this.clonedItem.emailVerified !== this.editedItem.emailVerified)
        return true;
      else return false;
    },
    newSponsorFlags() {
      return {
        Name: "custom:userFlags",
        Value: JSON.stringify(this.newSponsor.flags),
      };
    },
    newSponsorAtts() {
      return Object.entries(this.newSponsor.atts).map(([key, value]) => {
        if (key === "given_name" || key === "family_name") {
          let newValue = value.toLowerCase().trim();
          return {
            Name: key,
            Value: `${newValue.charAt(0).toUpperCase()}${newValue.slice(1)}`,
          };
        } else {
          return {
            Name: key,
            Value: value.trim(),
          };
        }
      });
    },
    newSponsorObject() {
      return {
        username: this.newSponsor.username.toLowerCase().trim(),
        password: this.newSponsor.password.trim(),
        newAtts: [...this.newSponsorAtts, this.newSponsorFlags],
      };
    },
  },
  methods: {
    iconTypeCheck(type) {
      let check1 = this.phonePrimary === this.currentPhones[type].type
      let check2 = this.copyCurrentPhones[type].number
      if (check1 || !check2) return false
      else return true
    },
    setupPhones() {
      let allPhones = JSON.parse(JSON.stringify(this.userInfo.phones))
      this.currentPhones.home = this.formatPhone(allPhones, "home")
      this.currentPhones.mobile = this.formatPhone(allPhones, "mobile")
      this.currentPhones.work = this.formatPhone(allPhones, "work")
      this.copyCurrentPhones = JSON.parse(JSON.stringify(this.currentPhones))
      this.copy = true
    },
    checkFlagsForSN() {
      if (
        this.userFlags.isAdmin ||
        this.userFlags.OCEAccess ||
        this.userFlags.CFUAccess
      )
        this.snPhoneId = this.$route.params.id;
      else this.snPhoneId = this.userInfo.alerus360id;
    },
    createEmptyPhone(type) {
      let phone = JSON.parse(JSON.stringify(this.emptyPhone))
      phone.type = type
      return phone
    },
    async removePhone(type) {
      await this.updatePhone(type, true)
    },
    // async removePhone(phoneId) {
    //   let res = await this.$store.dispatch("user/removeSecureNowPhone", {
    //     id: phoneId,
    //     user: this.snPhoneId,
    //   });
    //   if (res) {
    //     this.displayNotification("success", "phone");
    //   } else {
    //     this.displayNotification("error", "phone");
    //   }
    // },
    setUserMFA(info) {
      let mfa;
      let { snMFABypass, awsMFA, defaultMfa } = info;
      if (snMFABypass === "true") {
        mfa = "off";
      } 
      else if (defaultMfa) {
        if (defaultMfa === "sms" || defaultMfa === "voice") mfa = "securenow"
        else if (defaultMfa === "totp") mfa = "aws"
      }
      else if (snMFABypass === "false") {
        mfa = "securenow";
      }
      this.mfa = mfa;
      this.currentMFA = mfa;
    },
    async setMFA(item) {
      let set = await this.$store.dispatch("accounts/setUserMFA", {
        username: this.userInfo.username,
        mfa: this.mfa,
        a360id: this.userInfo.alerus360id
      });
      if (set) {
        this.currentMFA = item;
        this.displayNotification("success", "User MFA");
      } else {
        this.mfa = this.currentMFA;
        this.displayNotification("error", "User MFA");
      }
    },
    capitalize(item) {
      return item.slice(0, 1).toUpperCase() + item.slice(1);
    },
    appName(app) {
      return this.mersBranded && app === "MyAlerus"
        ? "Login"
        : this.mersBranded && app === "CSC"
        ? "CSR"
        : app;
    },
    async bypassMFA() {
      if (!this.superOrSysAdmin) return;
      let bypass = "True";
      if (this.snBypass === "True") bypass = "False";
      let data = await this.$store.dispatch("accounts/snBypassMFA", {
        username: this.userInfo.username,
        bypass: bypass.toLowerCase(),
      });
      if (data) this.userInfo.snMFABypass = bypass.toLowerCase();
    },
    formatPhone(phones, type) {
      let phone = phones.find(item => item.type === type) ? phones.find(item => item.type === type) : this.createEmptyPhone(type)
      let phoneNumber = phone.number.slice(phone.countryCode ? phone.countryCode.length + 1 : 2)
      phone.number = phoneNumber
      if (!phone.countryCode) phone.countryCode = "1"
      return phone
    },
    async updatePrimary() {
      if (!this.copyCurrentPhones[this.userInfo.primary].number || (this.phonePrimary === this.userInfo.primary)) {
        return
      }
      this.primaryLoading = true
      let phone = JSON.parse(JSON.stringify(this.currentPhones[this.userInfo.primary]))
      phone.number = `+${phone.countryCode}${phone.number}`
      let prevPhone = this.copyCurrentPhones[this.phonePrimary]
      let prev = `+${prevPhone.countryCode}${prevPhone.number}`
      await this.$store.dispatch("accounts/updatePhone", {
        username: this.userInfo.username,
        a360id: this.userInfo.alerus360id,
        phone,
        primary: true,
        prev,
        primaryUpdate: true,
        currType: this.capitalize(this.phonePrimary),
        newType: this.capitalize(this.userInfo.primary)
      })
      this.phonePrimary = this.userInfo.primary
      this.primaryLoading = false
    },
    checkDisabled(type) {
      let check1 = this.currentPhones[type].countryCode === "1" && this.currentPhones[type].number.length < 10
      let check2 = this.copyCurrentPhones[type].number === this.currentPhones[type].number
      if (check1 || check2) return true
      else return false
    },
    async updatePhone(type, remove = false) {
      if (this.checkDisabled(type) && !remove) return
      let phone;
      let loadType = `${type}Loading`
      this[loadType] = true
      if (remove) {
        phone = this.createEmptyPhone(type)
      }
      else {
        phone = JSON.parse(JSON.stringify(this.currentPhones[type]))
        phone.number = `+${phone.countryCode}${phone.number}`
      }
      let prevPhone = this.copyCurrentPhones[type]
      let prev = `+${prevPhone.countryCode}${prevPhone.number}`
      let res = await this.$store.dispatch("accounts/updatePhone", {
        username: this.userInfo.username,
        a360id: this.userInfo.alerus360id,
        phone,
        primary: type === this.phonePrimary ? true : false,
        prev: prevPhone.number ? prev : "NA",
        primaryUpdate: false
      })

      // Display notification
      if (res) {
        if (!remove) {
          this.copyCurrentPhones[type] = JSON.parse(JSON.stringify(this.currentPhones[type]))
        }
        else {
          this.currentPhones[type] = this.createEmptyPhone(type)
          this.copyCurrentPhones[type] = JSON.parse(JSON.stringify(this.currentPhones[type]))
        }
        this.displayNotification("success", `${this.capitalize(type)} phone`)
      }
      else this.displayNotification("error", type)
      this[loadType] = false
    },
    async generatePasscode() {
      if (!this.adminOrSuper) return;
      let code = Math.floor(100000 + Math.random() * 900000);
      let result = await this.$store.dispatch("accounts/sendCode", {
        message: code.toString(),
        number: this.clonedItem.phone,
      });
      if (result) {
        this.passCode = code;
      } else {
        this.passCode = "Error sending code";
      }
    },
    showActionDetails(item) {
      this.actionItem = item;
      this.actionDialog = true;
    },
    genPass() {
      if (!this.adminOrSuper) return;
      this.newSponsor.password = this.$generate({
        length: 12,
        numbers: true,
        symbols: true,
        strict: true,
        exclude: "\"`'",
      });
    },
    displayNotification(type, notification) {
      if (type === "success") {
        this.$snotify[type](`${notification} updated`);
      } else if (type === "number") {
        this.$snotify["error"](`${notification}`, "", {
          timeout: 0,
        });
      } else {
        this.$snotify[type](`Error updating ${notification}`, "", {
          timeout: 0,
        });
      }
    },
    async unlockSecureNow() {
      if (!this.adminOrSuper) return;
      let result = await this.$store.dispatch(
        "accounts/secureNowUnlock",
        this.snId
      );
      if (result) {
        this.$store.commit("accounts/setSecureNowStatus", false);
        await this.createUserLog(
          this.userInfo.username,
          "UnlockSecureNow",
          "CSC"
        );
        // this.$store.dispatch(
        //   "accounts/getUserAuthEvents",
        //   this.$route.params.id
        // );
      }
    },
    async createUserLog(username, log, app) {
      await this.$store.dispatch("accounts/createLog", {
        username: username,
        log: log,
        app: app,
      });
    },
    async changeUserAccount(status) {
      if (!this.adminOrSuper) return;
      if (!status) {
        let newStatus = await this.$store.dispatch(
          "accounts/disableUserAccount",
          this.userInfo.username
        );
        if (newStatus) {
          this.userInfo.enabled = false;
          // this.$store.dispatch(
          //   "accounts/getUserAuthEvents",
          //   this.$route.params.id
          // );
        } else this.userInfo.enabled = true;
      } else {
        let newStatus = await this.$store.dispatch(
          "accounts/enableUserAccount",
          this.userInfo.username
        );
        if (newStatus) {
          // this.$store.dispatch(
          //   "accounts/getUserAuthEvents",
          //   this.$route.params.id
          // );
          this.userInfo.enabled = true;
        } else this.userInfo.enabled = false;
      }
    },
    async resetPass() {
      if (!this.adminOrSuper) return;
      let newPass = await this.$store.dispatch(
        "accounts/resetUserPassword",
        this.userInfo.username
      );
      if (newPass) {
        this.userInfo.userStatus = "RESET_REQUIRED";
        await this.createUserLog(
          this.userInfo.username,
          "ResetPassword",
          "CSC"
        );
        // this.$store.dispatch(
        //   "accounts/getUserAuthEvents",
        //   this.$route.params.id
        // );
      } else console.log("failed to reset password");
    },
    async addSponsor() {
      if (!this.newSponsorObject.username || !this.newSponsorObject.password)
        return;
      this.newSponsor.atts.email = this.newSponsor.atts.email.toLowerCase();

      let sponsor = await this.$store.dispatch(
        "accounts/newSponsor",
        this.newSponsorObject
      );
      if (sponsor) {
        this.sponsor = false;
        this.newSponsor = this.sponsorCopy;
      }
    },
    async changePassword() {
      this.passwordInfo = "";
      let updated = await this.$store.dispatch("accounts/updateUserPassword", {
        username: this.userInfo.username,
        password: this.newPassword,
      });
      if (updated) {
        this.infoColor = "green";
        this.newPassword = "";
        this.passwordInfo = "Password updated successfully";
        await new Promise((resolve) => setTimeout(resolve, 4000));
        this.passwordInfo = "";
      } else {
        this.infoColor = "red";
        this.passwordInfo = "Error updating password";
      }
    },
    formatDate(date) {
      let month = date.slice(0, 2);
      let day = date.slice(2, 4);
      let year = date.slice(4, 8);
      return `${month}/${day}/${year}`;
    },
    resetAccounts() {
      this.$store.commit("accounts/resetUsers", this.allAccounts);
      this.errors.clear();
      this.dialog = false;
      this.emailError = "";
      this.clonedItem = {};
      this.editedItem = {};
    },
    setFlags(item) {
      let flags = {};
      if (item) {
        try {
          flags = JSON.parse(item);
        } catch (error) {}
      }
      this.userFlags = {
        isAdmin: flags.isAdmin !== undefined ? flags.isAdmin : false,
        isAlerus: flags.isAlerus !== undefined ? flags.isAlerus : false,
        isFCMM: flags.isFCMM !== undefined ? flags.isFCMM : false,
        isICapital: flags.isICapital !== undefined ? flags.isICapital : false,
        isKeating: flags.isKeating !== undefined ? flags.isKeating : false,
        isMERS: flags.isMERS !== undefined ? flags.isMERS : false,
        isEnvestnet:
          flags.isEnvestnet !== undefined ? flags.isEnvestnet : false,
        OCEAccess: flags.OCEAccess !== undefined ? flags.OCEAccess : false,
        CFUAccess: flags.CFUAccess !== undefined ? flags.CFUAccess : false,
        partAccess: flags.partAccess !== undefined ? flags.partAccess : false,
        isWexFLXAdmin: flags.isWexFLXAdmin !== undefined ? flags.isWexFLXAdmin : false,
        isMersContact: flags.isMersContact !== undefined ? flags.isMersContact : false,
        planAccessAdmin: flags.planAccessAdmin !== undefined ? flags.planAccessAdmin : false
      };
    },
    getItem(item) {
      this.$store.dispatch("accounts/getUserAuthEvents", item.username);
      this.setFlags(item);
      this.clonedItem = { ...item };
      this.allAccounts = this._.cloneDeep(this.accounts);
      this.editedItem = item;
      this.dialog = true;
    },
    findDifference() {
      let changes = Object.keys(this.clonedItem).filter(
        (prop) => this.clonedItem[prop] !== this.editedItem[prop]
      );
      return changes.map((item) => {
        return {
          Name: this.userAtts[item],
          Value: this.editedItem[item],
        };
      });
    },
    findKeys() {
      let newObject = {};
      let changes = Object.keys(this.clonedItem)
        .filter((prop) => this.clonedItem[prop] !== this.editedItem[prop])
        .forEach((item) => {
          newObject[item] = this.editedItem[item];
        });
      return newObject;
    },
    checkEmail() {
      if (this.userEmails.includes(this.editedItem.email)) return false;
      else return true;
    },
    async updateUser(name, value, type, notification, clonedName) {
      if (!this.adminOrSuper) return;
      if (value === undefined) {
        return;
      } else if (!this.userInfo.country) {
      } else if (this.clonedItem[clonedName] === value) {
        return;
      }

      let finalAtts = [];

      if (name === "email") {
        this.emailLoading = true
        finalAtts = [
          {
            Name: name,
            Value: value,
          },
          {
            Name: "email_verified",
            Value: "true",
          },
        ];
      } else if (name === "phone_number") {
        this.phoneLoading = true
        finalAtts = [
          {
            Name: name,
            Value: value,
          },
          {
            Name: "custom:countryCode",
            Value: this.country.replace("+", ""),
          },
          {
            Name: "userEmail",
            Value: this.userInfo.email,
          },
        ];
      } else {
        finalAtts = [
          {
            Name: name,
            Value: value,
          },
        ];
      }

      // Add current value for change
      finalAtts.push({
        Name: name,
        Value: this.clonedItem[clonedName] ? this.clonedItem[clonedName] : "",
      });

      let updated = await this.$store.dispatch("accounts/updateUserAtts", {
        userAtts: {
          username: this.userInfo.username,
          newAtts: finalAtts,
          a360id: this.userInfo.alerus360id
        },
      });
      if (updated) {
        this.$snotify.clear();
        this.displayNotification("success", notification);
        this.clonedItem[clonedName] = value;
        // this.$store.dispatch(
        //   "accounts/getUserAuthEvents",
        //   this.$route.params.id
        // );
        if (name === "email") {
          this.emailLoading = false
          this.userInfo.emailVerified = true;
        } else if (name === "phone_number") {
          this.phoneLoading = false
          this.userInfo.country = this.country.replace("+", "");
          // insert phone into Securenow
          await this.$store.dispatch("user/addSecureNowPhone", {
            full: finalAtts[0].Value.slice(1),
            country: finalAtts[1].Value,
            user: this.snPhoneId,
          });
        }
        this[type] = true;
        await new Promise((resolve) => setTimeout(resolve, 4000));
        this[type] = false;
      } else {
        this.phoneLoading = false
        this.emailLoading = false
        this.displayNotification("error", notification);
        this.userInfo[type] === this.clonedItem[type];
        if (name === "phone_number") {
          this.splitPhone();
        }
      }
    },
    async getAllEndpoints() {
      await Promise.all([
        this.getAccount(),
        this.getCallToAction(),
        this.getActionTags(),
        this.getFullAccount(),
      ]);
      this.dashboardReady = true;
    },
    async accountAuth() {
      let { data } = await $authUser.get(`/accountAuth`, {
        headers: {
          Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
        },
      });
      this.authToken = data;
    },
    async getAccount() {
      this.accountLoading = true;
      let { data: account } = await $authUser.get(`/accounts`, {
        headers: {
          Authorization: `Bearer ${this.authToken}`,
        },
      });
      this.account = account;
      this.accountLoading = false;
    },
    async getCallToAction() {
      this.actionLoading = true;
      let { data: actions } = await $authUser.get(`/callToAction`, {
        headers: {
          Authorization: `Bearer ${this.authToken}`,
        },
      });
      this.actions = actions;
      this.actionLoading = false;
    },
    async getActionTags(userId = 444455555, accountId = "00001555555") {
      this.actionTagsLoading = true;
      let { data: actionTags } = await $authUser.get(
        `/accounts/${accountId}/actionTags`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        }
      );
      this.actionTags = actionTags;
      this.actionTagsLoading = false;
    },
    splitPhone() {
      if (this.userInfo.country) {
        this.country = `+${this.userInfo.country}`;
        this.phone = this.userInfo.phone.replace(this.country, "");
      } else if (
        this.userInfo.phone.length === 12 &&
        this.userInfo.phone.substring(0, 2) === "+1"
      ) {
        this.country = this.userInfo.phone.substring(0, 2);
        this.phone = this.userInfo.phone.replace(this.country, "");
      } else {
        this.phone = this.userInfo.phone.replace("+", "");
        this.displayNotification(
          "number",
          "Please update country code and phone number"
        );
      }
    },
    async getFullAccount() {
      this.fullAccountLoading = true;
      let { data: full } = await $authUser.get(
        `https://api.alerus.com/accounts/00001555555?userHandle=444455555&participantId="partipandID"&planNumber=000015`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        }
      );
      this.fullAccount = full;
      this.fullAccountLoading = false;
    },
    async branchLookup(branchZip) {
      let { data: branch } = await $authUser.get(
        `/branchCodeLookup?zipCode=${branchZip}`
      );
      this.branchInfo = branch;
    },
    async getSystem(system = this.system) {
      this.newUrl = true;
      let { data: authSystem } = await $authUser.get(
        `/getSystemLink?system=${system}`,
        {
          headers: {
            Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
        }
      );
      this.authUrl = `https://applanding.alerus.com/?auth=${authSystem}`;
      this.newUrl = false;
    },
  },
  beforeDestroy() {
    this.$store.dispatch("accounts/logUnSubscribe");
    this.$store.dispatch("accounts/emptyInfo");
  },
};
</script>

<style lang="scss">
.user-title {
  justify-content: space-between;
  display: flex;
  width: 100%;
  .d-inline-flex {
    margin: 0;
  }
  .a360id {
    font-size: 1.25rem;
  }
}
.v-radio {
  .v-input--selection-controls__input {
    margin-right: 2px;
  }
}
.snotifyToast__title {
  font-size: 1.25rem;
}
.events {
  tr.row {
    cursor: pointer;
  }
}
.mers .headline {
  font-family: "Ubuntu" !important;
}
.mfa-label {
  label {
    font-size: 12px;
  }
}
.alt-phone {
  font-size: 16px;
}
.v-progress-linear{
  width: 50%;
  margin: 2rem auto;
}
.mobile-order {
  @media (max-width: 959px) {
    .md6 {
      order: 1;
    }
  }
}
</style>